<template>
  <main class="content pb-50 pt-30" style="min-height: 800px;">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <Sidenav />
        </div>
        <div class="col-md-9">
          <h2 class="header-title">Transaction History</h2>
          <div class="profile-details mt-20" v-if="Object.keys(transaction_history).length != 0">
            <div v-for="(history, index, i) in transaction_history" :key="index" :class="margin(i)">
              <span class="history-date">{{ index }}</span>
              <div class="row history-data my-2" v-for="(data, index2) in history" :key="index2">
                <div class="col-md-3 fw-bold">
                  {{ getTransactionTypeDisplay(data) }}
                </div>
                <div class="col-md-6">
                  <span>{{ getMessageDisplay(data) }}</span>
                  <span v-if="
                    data.amount && data.type === privilegeCardPurchaseType
                  " class="ml-1">Total: &#8369;{{ data.amount | currency }}
                  </span>
                  <div v-if="
                    typeof data.points_running_balance === 'number'
                  " class="mt-1">
                    <span class="mr-1">
                      {{
                        deductPointTypes.includes(data.type)
                          ? "Total Remaining Point"
                          : "Total Available Point"
                      }}{{
                        data.points_running_balance > 1 ? "s:" : ":"
                      }}
                    </span>
                    <span>{{ data.points_running_balance }}</span>
                    <i class="bi bi-star ml-1" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="col-md-3 text-md-right">{{ data.transaction_short_date + ' ' + data.transaction_time }}
                </div>
              </div>
            </div>
          </div>
          <div v-else class="d-flex flex-column justify-content-center align-items-center" style="min-height: 300px">
            <div v-if="loading" class="text-center h5 text-secondary">
              Loading...
            </div>
            <div v-else class="text-center">
              <img src="@/assets/images/transaction.svg" alt="" />
              <div class="h5 text-secondary">No Transactions</div>
              <div class="text-muted">There are no available transaction.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import $ from "jquery";
import Sidenav from "@/components/layout/Sidenav.vue";

const redeemRewardType = 0;
const privilegeCardPurchaseType = 12;

export default {
  data() {
    return {
      maxPage: 0,
      deductPointTypes: [redeemRewardType],
      privilegeCardPurchaseType
    };
  },
  components: {
    Sidenav,
  },
  created: async function () {
    this.$store.commit("transactions/RESET_TRANSACTION_HISTORY");
  },
  computed: {
    ...mapState("auth", {
      token: state => state.token,
    }),
    ...mapState("transactions", ['currentPage', "loading"]),
    ...mapGetters({
      max_page: "transactions/max_page",
      transaction_history: "transactions/transaction_history",
    }),
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken,
    }),

  },
  methods: {
    async getTransactionHistory(currentPage) {
      let request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        body: {
          currentPage: currentPage
        }
      };
      await this.$store.dispatch("transactions/getTransactionHistory", request);
      this.$forceUpdate();
      this.maxPage = this.max_page;
      if (this.currentPage < this.maxPage) {
        this.$store.commit("transactions/SET_CURRENT_PAGE", this.currentPage + 1);
      }
    },
    margin(index) {
      return (index == 0 ? 'mb-4' : 'my-4');
    },
    getTransactionTypeDisplay({ transaction_type, type }) {
      if (type === 11) return "eStore earned point/s";

      if (type === 41) return "eStore redeemed point/s";
     
      if (type === 42) return "eStore refunded point/s";

      if (type === 49 || type == 31) return "Survey Completed";

      return transaction_type;
    },
    getMessageDisplay({ message, points, type, reward }) {
      if (type === 11)
        return `Estore earned ${parseFloat(points)} point${parseFloat(points) > 1 ? 's' :
          ''}`;

      else if (type === 41)
        return `Redeemed ${Math.abs(parseFloat(points))} points${parseFloat(points) > 1 ? 's' : ''}`;
      
      else if (type === 49 && reward != null) {
        return `Earned reward/s: ${reward}`
      }
      else if (type === 31 && points != null) {
        return `Earned ${points} points from survey`
      }
      
      return message;
    }
  },
  watch: {
    currentPage() {
      this.getTransactionHistory(this.currentPage);
    }
  },
  mounted: () => {
    $("body").css({ backgroundColor: "#f4f5f8" });
  },
  filters: {
    currency(value) {
      if (!value) return "0";

      return Number(parseFloat(value).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
  }
};
</script>

<style scoped lang="scss">
@import "./../../assets/styles/views/profile/_base.scss";

.history-data {
  border: 1px solid #d8dcde;
  border-radius: 10px;
  list-style: none;
  padding: 15px;
  font-size: 14px;
}

.history-date {
  color: #6c757d !important;
}
</style>